/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaUrlResponse } from '../../models/media-url-response';

export interface MediaControllerGetUrl$Params {
  name: string;
}

export function mediaControllerGetUrl(http: HttpClient, rootUrl: string, params: MediaControllerGetUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaUrlResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerGetUrl.PATH, 'get');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaUrlResponse;
      }>;
    })
  );
}

mediaControllerGetUrl.PATH = '/file-manager/url/{name}';
